import React, { useEffect } from 'react'
import OneSignal from 'react-onesignal'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from 'src/_store/user.store'

let ONESIGNAL_INITIALIZED = false

export function OneSignalProvider({ children }: { children: React.ReactNode }) {
  const { user } = useUserStore((s) => ({ user: s.user }))
  const navigate = useNavigate();
  // After init, associate/log in the user, apply tags, and request permission if appropriate
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!user || !user.id) return
    OneSignal.init({
        appId: import.meta.env.VITE_ONESIGNAL_APP_ID,
        safari_web_id: import.meta.env.VITE_ONESIGNAL_SAFARI_WEB_ID,
      }).then(async () => {
      OneSignal.login(user.id.toString()).catch((e) => {
        console.log('OneSignal login error:', e)
      })
      OneSignal.User.addAlias('externalId', user.id.toString())
      if (user.userType) {
        try {
          OneSignal.User.addTag('role', String(user.userType).toLowerCase())
        } catch {}
      }
      
      // Auto-subscribe user to push notifications
      try {
        if ('Notification' in window) {
          if (Notification.permission === 'default') {
            // Request permission first
            await OneSignal.Notifications.requestPermission()
          }
          
          // If permission is granted, opt in the user
          if (Notification.permission === 'granted') {
            const isPushEnabled = await OneSignal.User.PushSubscription.optedIn
            if (!isPushEnabled) {
              console.log('Auto-subscribing user to push notifications')
              await OneSignal.User.PushSubscription.optIn()
            }
          }
        }
      } catch (error) {
        console.log('OneSignal subscription error:', error)
      }

      OneSignal.Notifications.addEventListener('click', function(event) {
      const url = event.notification.launchURL;
      if (url?.includes('http')) {
        window.location.href = url;
      } else {
        url && navigate(url);
      }
    });
    })
  }, [user])

  return <>{children}</>
}
